<template>
    <ul class="main">
        <li>
            <img :src="fileServerUrl+'assets/images/hyld-lb1.jpg'" />
            <div class="flag">
                战略会议
            </div>
        </li>
        <li>
            <img :src="fileServerUrl+'assets/images/hyld-lb1.jpg'" />
            <div class="flag">
                案例展示
            </div>
        </li>
        <li>
            <img :src="fileServerUrl+'assets/images/hyld-lb1.jpg'" />
            <div class="flag">
                技术秀
            </div>
        </li>
        <li>
            <img :src="fileServerUrl+'assets/images/hyld-lb1.jpg'" />
            <div class="flag">
                高层闭门
            </div>
        </li>
        <li>
            <img :src="fileServerUrl+'assets/images/hyld-lb1.jpg'" />
            <div class="flag">
                一对一引荐
            </div>
        </li>
        <li>
            <img :src="fileServerUrl+'assets/images/hyld-lb1.jpg'" />
            <div class="flag">
                高层闭门
            </div>
        </li>

    </ul>
</template>

<script>
    export default {
        data() {
            return {
                fileServerUrl:fileServerUrl,
            };
        },
       methods:{

       }

    }
</script>

<style lang="scss" scoped>
    *{

        margin:0;
        padding:0;
    }
    ul,ol{
        list-style:none;
    }
    .main{
        width:100%;
        height:300px;
        margin:150px auto;
        overflow: hidden;
    }

    li{
        width: 120px;
        float: left;
        //border-left: 1px solid #a2a9b6;
        position: relative;
        transition: all 1s;


    }

    .flag{
        position: absolute;
        left: 0;
        bottom: 7%;
        width: 100%;
        height:50px;
        line-height:35px;
        text-align: center;
        color: #fff;
        background: rgba(0,0,0,0.5);
    }

    .main:hover li{
        width: 45px;
    }

    .main li:hover{
        width: 500px;
    }



</style>
